import React, { useEffect, useRef } from "react";
import useUndoRedo from "../../../../hooks/useUndoRedo";
import TextArea from "antd/es/input/TextArea";
const HTextArea = ({ value, setValue, onChange, disabled, ...props }, ref) => {
  const { value: localValue, updateValue, undo, redo } = useUndoRedo(value || "");
  const textAreaRef = useRef(null);

  useEffect(() => {
    if (value !== undefined && value !== localValue) {
      updateValue(value);
    }
  }, [value]);


  useEffect(() => {
    setValue?.(localValue);
  }, [localValue]);


  const handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
      e.preventDefault();
      if (e.shiftKey) {
        // Redo: Cmd+Shift+Z (Mac) or Ctrl+Shift+Z (Windows)
        redo();
      } else {
        // Undo: Cmd+Z (Mac) or Ctrl+Z (Windows)
        undo();
      }
    } else if ((e.ctrlKey || e.metaKey) && e.key === 'y') {
      // Redo: Ctrl+Y (Windows alternative)
      e.preventDefault();
      redo();
    }
    props?.onKeyDown?.(e);
  };

  const handleChange = (e) => {
    updateValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <TextArea
      {...props}
      ref={ref || textAreaRef}
      value={localValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      disabled={disabled}
    />
  );
};

export default React.forwardRef(HTextArea);
